import { render, staticRenderFns } from "./CModal.vue?vue&type=template&id=1eb502a5&lang=pug&"
import script from "./CModal.vue?vue&type=script&lang=ts&"
export * from "./CModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports